import React from 'react';
import { Source, Layer } from 'react-map-gl';

interface IJobPolygonProps {
  coordinates: [number, number][];
  sourceId?: string;
  fillId?: string;
  lineId?: string;
}

const JopPolygon: React.FC<IJobPolygonProps> = ({
  coordinates,
  sourceId = 'maine',
  fillId = 'fill',
  lineId = 'outline',
}) => {
  return (
    <Source
      id={sourceId}
      type="geojson"
      data={{
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: [
            coordinates.map((coordinate: [number, number]) => [...coordinate].reverse() as [number, number]),
          ],
        },
      }}
    >
      <Layer
        id={fillId}
        type="fill"
        source={sourceId}
        paint={{
          'fill-color': '#ff6f00',
          'fill-opacity': 0.4,
        }}
      />
      <Layer
        id={lineId}
        type="line"
        source={sourceId}
        paint={{
          'line-color': '#ff6f00',
          'line-width': 2,
        }}
      />
    </Source>
  );
};

export default JopPolygon;
